import xml from "csi/xml";
import _Query from "./_Query";
import { C8PrimitiveValue } from "csi/typings";

class ExtractQuery extends _Query {
	constructor(doc?: XMLDocument, element?: Element) {
		super(doc, element);
	}

	/**
	 * Return root tag for query
	 */
	override get rootTag(): string {
		return "FILTERS";
	}

	/**
	 * Add query filter for given classifier key
	 */
	Filter(classifierKey: string, op: string, value: C8PrimitiveValue): this {
		const { doc, element } = this;
		const node = xml.e(doc, "Filter", element);

		node.setAttribute("Key", classifierKey);
		node.setAttribute("Op", op);

		if (xml.opHasValue(op)) {
			this._setValueProperty(node, op, "Value", value);
		}

		return this;
	}

	/**
	 * Or is implied if filtering multiple times against same key
	 */
	Or(): _Query {
		return this;
	}
};

export = ExtractQuery;